export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тейкер"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мейкер"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тейкер ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мейкер ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы платите"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы получаете"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Время ожидания"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Банковский счет/Кошелек"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Описание"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет названия банка"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет банковского счета"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя не указано"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счет не указан"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Внешний"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Внутренний"])}
}